import { Fragment, useMemo, useState } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import className from 'classnames';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const EcosystemC = () => {
    const [active, setActive] = useState(0);
    const { t } = useLang('theProduct.EcosystemC');

    const list = [
        {
            banner: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760594468518/tab1-pc.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1760594466757/tab1-h5.jpg',
            },
            title: t(`tab1_title`),
            desc: t(`tab1_desc`),
            subs: [
                {
                    title: t(`tab1_sub1`),
                    href: 'https://www.ecoflow.com/us/ocean-pro-home-solar-battery',
                    btn: t(`learn_more`),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760600414002/tab1_sub1.png',
                },
            ],
        },
        {
            banner: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760594468210/tab2-pc.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1760594467983/tab2-h5.jpg',
            },
            title: t(`tab2_title`),
            desc: t(`tab2_desc`),
            subs: [
                {
                    title: t(`tab2_sub1`),
                    href: 'https://www.ecoflow.com/us/ocean-smart-electrical-panel-40',
                    btn: t(`learn_more`),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760946726648/tab2_sub1.png',
                },
                {
                    title: t(`tab2_sub2`),
                    href: 'https://www.ecoflow.com/us/ocean-smart-meter-backup-switch',
                    btn: t(`learn_more`),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760600414199/tab2_sub2.png',
                },
                {
                    title: t(`tab2_sub3`),
                    btn: t(`coming_soon`),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760693679462/tab2_sub3.png',
                },
            ],
        },
        {
            banner: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760594466888/tab3-pc.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1760594467791/tab3-h5.jpg',
            },
            title: t(`tab3_title`),
            desc: t(`tab3_desc`),
            subs: [
                {
                    title: t(`tab3_sub1`),
                    href: 'https://www.ecoflow.com/us/ocean-ev-charger',
                    btn: t(`learn_more`),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760600415011/tab3_sub1.png',
                },
            ],
        },
        {
            banner: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760594467386/tab4-pc.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1760594467153/tab4-h5.jpg',
            },
            title: t(`tab4_title`),
            desc: t(`tab4_desc`),
            subs: [
                {
                    title: t(`tab4_sub1`),
                    btn: t(`coming_soon`),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760600414862/tab4_sub1.png',
                },
                {
                    title: t(`tab4_sub2`),
                    href: 'https://www.ecoflow.com/us/app',
                    btn: t(`learn_more`),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760600414625/tab4_sub2.png',
                },
            ],
        },
    ];

    const activeData = useMemo(() => {
        return list[active];
    }, [active]);

    const handleTab = (tab: (typeof list)[0], index: number, e: React.MouseEvent<HTMLDivElement>) => {
        setActive(index);
        gtm.push({
            __btn_id1: `EcosystemC ${'.tab' + index}`,
            __btn_id2: tab.title,
            __btn_type: 'common',
        });

        e.currentTarget.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
        });
    };

    const handleClick = (sub: (typeof list)[0]['subs'][0], index: number) => {
        gtm.push({
            __btn_id1: `EcosystemC ${'.' + active + 'sub' + index}`,
            __btn_id2: sub.title,
            __btn_type: sub.href ? 'href' : 'common',
        });
    };

    const Icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
            <path d="M0.699869 0.700013L6.0332 6.03335L0.69987 11.3667" stroke="#3F68E0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    return (
        <div className={`${styles.EcosystemC} EcosystemC GtmModuleData-section`} id="EcosystemC" data-section-id={styles.EcosystemC}>
            {list.map(({ banner }, index) => (
                <EcoImg pc={banner.pc} pad={banner.h5} className={className('banner', { active: active === index })} key={banner.pc} />
            ))}

            <div className="content">
                <div className="text-container">
                    <h2>{t(`title`)}</h2>
                    <p className="desc">{t(`desc`)}</p>
                </div>
                <div className="tabs">
                    <div className="container">
                        {list.map((item, index) => (
                            <h3
                                key={item.title}
                                className={className(`tab GtmModuleData-btn-common ${'tab' + index}`, { active: active === index })}
                                onClick={(e) => handleTab(item, index, e)}
                            >
                                {item.title}
                            </h3>
                        ))}
                    </div>
                </div>
                <div className="sub-container">
                    <p className="desc">{activeData.desc}</p>
                    <div className={className('sub-list', { single: activeData.subs.length === 1, multiple: activeData.subs.length > 1 })}>
                        {activeData.subs.map((item, index) => (
                            <Fragment key={item.title}>
                                <div className="sub-item">
                                    <EcoImg pc={item.img} className="product" />
                                    <div className="text-box">
                                        <h4>{item.title}</h4>
                                        {item.href ? (
                                            <a
                                                href={item.href}
                                                className={`btn GtmModuleData-btn-href ${active + 'sub' + index}`}
                                                onClick={() => handleClick(item, index)}
                                                target="_blank"
                                            >
                                                {item.btn}
                                                {Icon}
                                            </a>
                                        ) : (
                                            <button
                                                className={`btn GtmModuleData-btn-common comming-soon ${active + 'sub' + index}`}
                                                onClick={() => handleClick(item, index)}
                                            >
                                                {item.btn}
                                            </button>
                                        )}
                                    </div>
                                </div>
                                {index < activeData.subs.length - 1 && <div className="line" />}
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
            {activeData.subs.map((item) => (
                <div key={item.title} className="space" />
            ))}
        </div>
    );
};

export default EcosystemC;
